const env = "local";

const urls = {
  local: "http://localhost",
  staging: "https://ofpro.loqusgroup.com",
  production: "https://management.openfleetpro.com",
};

const config = {
  apiAddress: {
    main: {
      url: urls[env] + (env === "local" ? ":" + 3022 : ""),
      virtualPath: "/proapi/",
    },
    pro_client: {
      url: urls[env] + (env === "local" ? ":" + 8445 : ""),
      virtualPath: "/procliapi/",
      suffixPath: "/route",
    },
    intapi: {
      url: urls[env] + (env === "local" ? ":" + 3002 : ""),
      virtualPath: "/intapi/",
      suffixPath: "/route",
    },
    login: {
      url: urls[env] + (env === "local" ? ":" + 3098 : ""),
      virtualPath: "/loginapi/",
      suffixPath: "/route",
    },
    disapi: {
      url: urls[env] + (env === "local" ? ":" + 8442 : ""),
      virtualPath: "/disapi/",
      suffixPath: "/dispatch",
    },
    clientin: {
      url: urls[env] + (env === "local" ? ":" + 8420 : ""),
      virtualPath: "/api/in/",
      suffixPath: "/route",
    },
    mdapi: {
      url: urls[env] + (env === "local" ? ":" + 1025 : ""),
      virtualPath: "/mdapi/api/v1/",
      suffixPath: "/route",
    },
  },

  websocketConfig: {
    clients: {
      url: urls[env] + (env === "local" ? ":" + 3114 : ""),
      virtualPath: "cliskt",
      // suffixPath: null // eg. /route
    },
    settings: {
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      randomizationFactor: 0.5,
    },
  },
};

export default config;
